import React from "react"
import styles from './TermsOfService.module.scss'

export default function TermsOfService() {
    const year = new Date().getFullYear()

    return (
        <div className={styles.terms}>
            <h3 className={styles.title}>Terms of Service</h3>
            <p className={styles.updated}>Last updated: {year}</p>
            <div className={styles.body}>
                <section>
                    <h4>1. Acceptance of these terms</h4>
                    <p>
                        By accessing or using this site, you agree to be bound by these Terms of
                        Service. If you do not agree with any part of these terms, please do not
                        use the site.
                    </p>
                </section>
                <section>
                    <h4>2. About this site</h4>
                    <p>
                        This site is operated by Julian Capilla as a personal portfolio and a set
                        of free utility tools (such as the JSON editor and converter). It is
                        provided to showcase work and skills, and is not, by itself, a contractual
                        offer of services. Any engagement for consulting or development work is
                        subject to a separate agreement between the parties.
                    </p>
                </section>
                <section>
                    <h4>3. Use of the tools</h4>
                    <p>
                        The utilities available on this site are provided for your convenience,
                        "as is" and without warranty of any kind, express or implied, including
                        but not limited to fitness for a particular purpose, accuracy, or
                        availability. You are responsible for reviewing any output before relying
                        on it, and for keeping backups of data you process here.
                    </p>
                </section>
                <section>
                    <h4>4. Acceptable use</h4>
                    <p>
                        You agree not to misuse the site — including attempting to disrupt its
                        availability, probing it for vulnerabilities without authorization, or
                        using it to store or transmit unlawful content.
                    </p>
                </section>
                <section>
                    <h4>5. Intellectual property</h4>
                    <p>
                        The site's design, content, and branding are the property of Julian
                        Capilla unless otherwise noted. Third-party libraries and assets remain
                        the property of their respective owners and are used under their
                        applicable licenses.
                    </p>
                </section>
                <section>
                    <h4>6. Limitation of liability</h4>
                    <p>
                        To the fullest extent permitted by law, Julian Capilla shall not be liable
                        for any indirect, incidental, or consequential damages arising from your
                        use of this site or its tools.
                    </p>
                </section>
                <section>
                    <h4>7. Third-party links</h4>
                    <p>
                        This site links to third-party destinations (such as LinkedIn) for your
                        convenience. Those sites are governed by their own terms and privacy
                        policies, which are not controlled by Julian Capilla.
                    </p>
                </section>
                <section>
                    <h4>8. Changes to these terms</h4>
                    <p>
                        These terms may be updated from time to time. Continued use of the site
                        after a change is posted constitutes acceptance of the revised terms.
                    </p>
                </section>
                <section>
                    <h4>9. Governing law</h4>
                    <p>
                        These terms are governed by the laws of [your jurisdiction], without
                        regard to its conflict of law provisions.
                    </p>
                </section>
                <section>
                    <h4>10. Contact</h4>
                    <p>
                        Questions about these terms can be sent through the Contact link in the
                        site footer.
                    </p>
                </section>
            </div>
        </div>
    )
}
